var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons / 18 / Outline / Info"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16ZM8.83117 5.93506H7.12987V13H8.83117V5.93506ZM7.25974 3.25974C7.08658 3.4329 7 3.67532 7 3.98701C7 4.29004 7.08658 4.52814 7.25974 4.7013C7.4329 4.87446 7.671 4.96104 7.97403 4.96104C8.29437 4.96104 8.5368 4.87446 8.7013 4.7013C8.87446 4.52814 8.96104 4.29004 8.96104 3.98701C8.96104 3.67532 8.87446 3.4329 8.7013 3.25974C8.52814 3.08658 8.28571 3 7.97403 3C7.671 3 7.4329 3.08658 7.25974 3.25974Z",
    fill: "#7D7D7D"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.9ff365f33f72d7ab9420580d4ab36439.svg";
export { ForwardRef as ReactComponent };